<template>
  <form @submit.prevent="onSubmit">
    <div class="row align-items-center">
      <div class="col-lg-4 col-md-4" v-if="!isCreateUserMode">
        <input id="feature-product-image" type="hidden" @change="onFileChange"/>

        <div class="text-center">
          <img alt="user-profile-image" class="user-profile-image " :src="form.profileImagePreview"/>
        </div>

        <label class="btn w-100 btn-secondary rounded-pill">
          <span v-t="`user.profile.image_picker`"></span>
          <input type="file" @change="onFileChange" style="display: none;">
        </label>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-name" v-t="`user.profile.name`"></label>
          <input v-model="form.name" type="text" class="form-control" id="form-name">
          <form-errors-manager :validation="v$.form.name"/>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-last_name" v-t="`user.profile.last_name`"></label>
          <input v-model="form.last_name" type="text" class="form-control" id="form-last_name">
          <form-errors-manager :validation="v$.form.last_name"/>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-email" v-t="`user.profile.email`"></label>
          <input v-model="form.email" type="text" class="form-control" id="form-email">
          <m-a class="text-decoration-none" :href="{name:'VerifyEmailRequest'}"
               v-if="!isCreateUserMode && form.email_verified_at == null"
               v-t="`user.profile.email_verified_link`"></m-a>
          <form-errors-manager :validation="v$.form.email"/>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-cellphone" v-t="`user.profile.cellphone`"></label>
          <input v-model="form.cellphone" type="text" class="form-control" id="form-cellphone">
          <m-a class="text-decoration-none" :href="{name:'VerifiedCellphone'}"
               v-if="!isCreateUserMode && form.cellphone_verified_at == null"
               v-t="`user.profile.cellphone_verified_at`"></m-a>
          <form-errors-manager :validation="v$.form.cellphone"/>
        </div>
      </div>

      <div class="col-lg-4 col-md-4" v-if="isAdmin">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-cellphone" v-t="`user.profile.order_notification`"></label>
          <select class="custom-select" v-model="form.order_notification">
            <option v-for="item in order_notification" :value="item.value">{{ item.text }}</option>
          </select>

          <form-errors-manager :validation="v$.form.order_notification"/>
        </div>
      </div>


      <div class="col-12">
        <div class="form-group">

          <m-advance-description1 :inputsConfig="advanceDescriptionInputs" :description="form.description"
                                  v-model="form.description"
                                  item-class="col-lg-12"
                                  v-if="advanceDescription"/>
          <template v-else>
            <label class="form-label-wrapper" for="form-description" v-t="`user.profile.description`"></label>
            <textarea v-model="form.description" type="text" class="form-control" id="form-description"></textarea>
          </template>
          <form-errors-manager :validation="v$.form.description"/>
        </div>
      </div>


    </div>

    <div class="row" v-if="isCreateUserMode">
      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-password" v-t="`user.profile.password`"></label>
          <input v-model="form.password" type="password" class="form-control" id="form-password">
          <form-errors-manager :validation="v$.form.password"/>
        </div>
      </div>

      <div class="col-lg-4 col-md-4">
        <div class="form-group">
          <label class="form-label-wrapper" for="form-password-confirmation" v-t="`user.profile.password_confirmation`"></label>
          <input v-model="form.password_confirmation" type="password" class="form-control"
                 id="form-password-confirmation">
          <form-errors-manager :validation="v$.form.password_confirmation"/>
        </div>
      </div>
    </div>


    <div class="row">
      <button type="submit" class="w-100 mt-4 btn btn-primary rounded-pill"
              v-t="`user.profile.submit_button`"></button>
    </div>

  </form>
</template>

<script>
import {useVuelidate} from '@vuelidate/core'
import {required, requiredIf, email,} from '@vuelidate/validators'
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {rolesTranslate} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import {userAvatar} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import {mapGetters} from "vuex";
import mA from '../../Tags/A.vue'
import mAdvanceDescription1 from "../../AdvanceDescription/AdvanceDescription1.vue";

export default {
  name: "UserProfile1",
  props: {
    advanceDescription: {
      type: Boolean,
      default: false,
    },
    advanceDescriptionInputs: {
      default: '[ { "name": "کد ملی", "placeholder": "", "regex": "^[0-9]*$", "required": true, "type": "text" }, { "name": "شماره حساب", "placeholder": "", "regex": "", "required": true, "type": "number" } ]',
    },
    loadUserProfile: {
      default: false,
      type: Boolean,
    }
  },
  components: {FormErrorsManager, mA, mAdvanceDescription1},
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      userAvatar,
      rolesTranslate,
      form: {
        id: '',
        name: '',
        last_name: '',
        order_notification: 0,
        email: '',
        email_verified_at: '',
        role: 1,
        cellphone: '',
        cellphone_verified_at: '',
        image: null,
        description: null,
        type: 1,
      },
      roles: [
        {text: "کاربر عادی", value: 0},
        {text: "مدیر سایت", value: 1},
        {text: "فروشگاه", value: 2},
        {text: "ویرایشگر", value: 3},
        {text: "نویسنده", value: 4},
        {text: "مدیریت سفارشات", value: 5},
      ],
      order_notification: [
        {text: this.$t('user.order_notification.disable'), value: 0},
        {text: this.$t('user.order_notification.active'), value: 1},
      ],
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
    }),
    getUserIdFromUrl() {
      return this.$route.params.id
    },
    isUserInUpdateRoute() {
      return this.$route.name == 'UpdateUser'
    },
    getUserIdFromLoginUser() {
      return this.$store.getters['User/getProfile'].id
    },
    isCreateUserMode() {
      return this.$route.name === 'CreateUser'
    }
  },
  methods: {
    setForm(form) {
      this.form = {}
      this.form = form
      this.form.profileImagePreview = this.form.image == null ? this.userAvatar : this.form.image
      this.form.image = null
    },
    async loadUserData() {

      let userId = null;
      if (this.loadUserProfile || this.$route.name === 'Profile') {
        userId = this.getUserIdFromLoginUser
      }

      if (this.isUserInUpdateRoute) {
        userId = this.getUserIdFromUrl
      }

      let response = await this.$store.dispatch("User/getPerson", userId)
      response = response.data.data
      this.setForm(response)
    },
    initComponent() {


      this.loadUserData()

    },
    async onSubmit() {
      const result = await this.v$.form.$validate()
      if (!result) return


      if (this.isCreateUserMode) {
        await this.$store.dispatch("User/createPerson", this.form);
      } else {
        let form = Object.assign({}, this.form)
        form.password = null
        form.password_confirmation = null
        form.current_password = null
        let panels = []
        form.panels.forEach(item => {
          panels.push(item.language_id)
        })
        form.panels = panels

        let response = await this.$store.dispatch("User/updatePerson", form)
        response = response.data.data.user
        this.setForm(response)
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.profileImagePreview = URL.createObjectURL(file);
    },
  },
  validations() {
    if (this.isCreateUserMode) {

      return {

        form: {
          name: {required},
          last_name: {required},
          cellphone: {required, phone},
          email: {
            required: requiredIf(function () {
              return this.form.email != null && this.form.email != "";
            }),
            email,
          },
          role: {required},
          order_notification: {required},
          password: {required},
          password_confirmation: {required},
          description: {},
          profileImagePreview: {},
        }
      }
    }

    return {
      form: {
        name: {required},
        last_name: {required},
        cellphone: {required, phone},
        email: {
          required: requiredIf(function () {
            return this.form.email != null && this.form.email != "";
          }),
          email,
        },
        role: {required},
        order_notification: {required},
        description: {},
        profileImagePreview: {},
      }
    }

  },
  mounted() {
    this.form.profileImagePreview = this.userAvatar
    this.initComponent()
  }
}
</script>

<style scoped>
.user-profile-image {
  height: 150px;
  width: auto;
  object-fit: contain;
}
.form-label-wrapper{
  margin-top: 15px;

}
</style>